import React, { useCallback } from 'react';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { Colors, Toggle } from '../../../ui';
import { PropertyFacade } from '../../canvas/properties/PropertyFacade';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Copy, Flexer } from '../../dashboard/elements/LayoutElements';
import { DropZone } from './DropZone';

type Value = {
    allowMultiple: boolean,
    allowPeeking: boolean,
};

export const DropZoneSettingsWidgetValue = (adapter: PropertyFacade<DropZone>): Value => ({
    allowMultiple: adapter.get('allowPeeking'),
    allowPeeking: adapter.get('allowMultiple'),
});

export const DropZoneSettingsWidget = React.memo<{ widget: PopoutWidget }>(({ widget }) => {

    const values = useObserver(widget).value as Value;

    const set = useCallback((patch: Record<string, boolean>) => {
        widget.update({ value: ({ ...values, ...patch }) });
    }, [values]);

    return <Flexer width="16" flex="column" gap="1" padding="1" color={Colors.text}>
        <Flexer flex="row" align="center" justify="space-between">
            <Copy flush>Allow Multiple</Copy>
            <Toggle size="sm" value={values.allowMultiple} onAction={x => set({ allowMultiple: x })} />
        </Flexer>
        <Flexer flex="row" align="center" justify="space-between">
            <Copy flush>Allow Peeking</Copy>
            <Toggle size="sm" value={values.allowPeeking} onAction={x => set({ allowPeeking: x })} />
        </Flexer>
    </Flexer>;
});
